import React, { Component } from 'react'
import classNames from 'classnames';
//import '../../css/App.css';

class History extends Component {

  render() {
    return (
        <div className="mt-2">
            <h3 className="font-bold">History</h3>
            <div className="flex flex-wrap flex-row-reverse justify-end">
                { 
                    this.props.history.map((color, index) => {
                        return (
                            <div className={classNames({ 'cursor-dropper': (this.props.tool === 'dropper') }, { 'cursor-palette': (this.props.tool === 'palette') }, 'shadow', 'overflow-hidden', 'rounded', 'mr-1', 'h-10', 'w-10')} key={index} onClick={() => this.props.handleClick(color)} 
                                style={{ backgroundColor: color }}>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
  }
}

export default History;
